import { useContext, useEffect } from "react";

import { FormContext } from "./AppForm";
import { useTranslation } from "react-i18next";

function FirstStepA() {
  const { values, errors, handleChange, setValues } =
    useContext<any>(FormContext);
  const { t } = useTranslation();
  const param = new URLSearchParams(window.location.search).get("on_behalf");

  return (
    <div className="form-center">
      <h1>{t("signup__project_name_question")}</h1>
      <h2>{t("signup__project_name_paragraph")}</h2>
      <div className="form-center-input">
        <div className="registration">
          <label htmlFor="pname" className="inputFieldName">
            {t("signup__project_name_label")}
          </label>

          <input
            value={values.project_name}
            required
            onChange={handleChange}
            type="text"
            className="pname"
            id="project_name"
            name="project_name"
            onBlur={handleChange}
          />
          {param === "zooza" && (
            <div className="zooza">
              <input
                placeholder="Email zadavateľa"
                aria-label="acquired_by"
                id="acquired_by"
                name="acquired_by"
                onChange={handleChange}
                type="email"
                className="pname"
                value={values.acquired_by}
              />

              <input
                placeholder="Meno"
                aria-label="first_name"
                id="first_name"
                name="first_name"
                onChange={handleChange}
                type="text"
                className="pname"
                value={values.first_name}
              />
              <input
                placeholder="Priezvisko"
                aria-label="last_name"
                id="last_name"
                name="last_name"
                onChange={handleChange}
                type="text"
                className="pname"
                value={values.last_name}
              />
            </div>
          )}

          <span className="error">{errors.project_name}</span>
        </div>
      </div>
    </div>
  );
}
export default FirstStepA;
